import { z } from 'zod';
import { ObjectId } from 'bson';

export const objectIdSchema = z
  .union(
    [
      // Case 1: Proper ObjectId instance
      z.instanceof(ObjectId).transform(id => id.toHexString()),

      // Case 2: Serialized ObjectId ({ _bsontype: 'ObjectID' })
      z
        .object({
          _bsontype: z.literal('ObjectID'),
          id: z.union([z.instanceof(Buffer), z.array(z.number())]),
        })
        .transform(serialized => {
          // Handle both Buffer and number[] cases
          const buffer = Array.isArray(serialized.id) ? Buffer.from(serialized.id) : serialized.id;
          return new ObjectId(buffer).toHexString();
        }),

      // Case 3: Already a string
      z.string().regex(/^[0-9a-fA-F]{24}$/),
    ],
    {
      errorMap: (issue, ctx) => {
        if (issue.code === z.ZodIssueCode.invalid_union) {
          return {
            message: 'Must be a valid ObjectId, serialized ObjectId or 24-character hex string',
          };
        }
        return { message: ctx.defaultError };
      },
    }
  )
  .pipe(z.string()) as z.ZodType<string>;
// .superRefine((val, ctx) => {
//   console.log('[DEBUG] Validation path:', ctx.path);
//   console.log('[DEBUG] Validation value:', val);
// });

// Utility function to add an objectId as a field with specific name. Like this:

// type Item = { name: string };
// const DepartmentIdSchema = idFieldObjectSchema('departmentId');
// type DepartmentId = z.infer<typeof DepartmentIdSchema>; // { departmentId: string }
// type ItemWithDepartmentId = Item & DepartmentId;
// => { name: string; departmentId: string }

export const idFieldObjectSchema = <K extends string>(key: K) =>
  z.object({ [key]: objectIdSchema } as Record<K, typeof objectIdSchema>);
